<div class="hottext-option" [ngClass]="{
        'hottext-option--highlighted': isHighlighted,
        'hottext-option--correct': answerState === answerStateEnum.Correct,
        'hottext-option--incorrect': answerState === answerStateEnum.InCorrect
    }">
    <ng-content></ng-content>

    <app-state-icon [state]="answerState"></app-state-icon>
</div>

